import { setError } from 'store/actions/auth';
import {
  loading,
  setKasbonInqRes,
  setRayanetInqRes,
  setVerifyPayroll,
  setIsRayaEmployed
} from 'store/actions/loanApply';

/**
 * to handle success response from verifyPayroll service
 * @param {*} dispatch
 * @param {*} res
 * @param {*} body
 * @param {*} action
 * @param {*} getState
 * @returns
 */

const handleKasbonReference = (kasbonReferenceVO, dispatch) => {
  if (kasbonReferenceVO) {
    dispatch(setKasbonInqRes(kasbonReferenceVO));

    if (kasbonReferenceVO.isEligibleKasbon === 'N') {
      const errorKey = kasbonReferenceVO.eligibilityDate
        ? 'not_eligible_date_kasbon'
        : 'not_eligible_min_plafond_kasbon';

      dispatch(setError(errorKey));
      dispatch(loading(false));
      return;
    }
  }
};

export const handleSuccessVerifyPayroll = (
  dispatch,
  resData,
  param,
  action,
  getState
) => {
  const isRayaEmployed = resData?.whitelistReferenceVO?.isRayaEmployed;
  const isSecondApply = getState().loanApply.appInqRes.isSecondApply;
  const applicationStatus =
    getState().loanApply.appInqRes?.applicationStatus?.cmCode;
  const suplesiStatus =
    getState().loanApply.appInqRes?.suplesiData?.applicationStatus;
  if (!resData) {
    dispatch(setError('system'));
    dispatch(loading(false));
    return;
  }

  dispatch(setVerifyPayroll(resData));

  if (
    isSecondApply === 'Y' &&
    applicationStatus !== 'PAYROLL_APP' &&
    suplesiStatus !== 'PAYROLL_APP'
  ) {
    dispatch(setIsRayaEmployed(isRayaEmployed || 'N'));
  }

  const { rayanetInquiryReferenceVO, kasbonReferenceVO } = resData;

  const shouldSetRayanet =
    !param?.isFlowSuplesiActive && rayanetInquiryReferenceVO;

  if (shouldSetRayanet) {
    dispatch(setRayanetInqRes(rayanetInquiryReferenceVO));
  }

  handleKasbonReference(kasbonReferenceVO, dispatch);

  action?.(resData);
  if (param?.loading) dispatch(loading(false));
};
